// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'
import {JobStatus} from "../../../../interfaces/JobStatus";
import {JobStatusLogView} from "../job_status_log_view/JobStatusLogView";
import {JobStatusUpdater} from "../../../../services/JobStatusUpdater";

@Component({
    components: {
        JobStatusLogView
    },
    mixins: [
        template,
    ]
})
export class JobStatusLogViewDefault extends Vue {

    @Prop()
    public jubUuid!: string

    @Prop({default: 400})
    public maxHeight!: number

    @Prop()
    public language!: string

    @Prop({default: 1000})
    public updateInterval!: number

    private status: JobStatus|null = null;

    private statusUpdater: JobStatusUpdater|null = null

    public mounted() {
        this.statusUpdater = new JobStatusUpdater(
            this.jubUuid,
            this.updateInterval,
            this.language
        )
        this.statusUpdater.start((status) => {
            this.status = status;
        })
    }

    public beforeDestory() {
        if (this.statusUpdater) {
            this.statusUpdater.stop();
        }
    }

    @Watch('status')
    public onStatusChange(newStatus, oldStatus) {
        if (oldStatus && newStatus && oldStatus.queue_status != newStatus.queue_status) {
            this.$emit('queue-status', newStatus.queue_status);
        }
    }

    @Watch('jubUuid')
    public onJobUuidChange() {
        if (this.statusUpdater) {
            this.statusUpdater.jobUuid = this.jubUuid
        }
    }

    @Watch('updateInterval')
    public onUpdateIntervalChange() {
        if (this.statusUpdater) {
            this.statusUpdater.updateInterval = this.updateInterval
        }
    }

    @Watch('language')
    public onLanguageChange() {
        if (this.statusUpdater) {
            this.statusUpdater.language = this.language
        }
    }
}